import React from "react";
import ProjectsAnimation from "../components/Projects/ProjectsAnimation";
import BuyMeAChaiPage from "../components/Projects/BuyMeAChaiPage";

const BuyMeAChai = () => {
  return (
    <div className="z-30 relative">
      <ProjectsAnimation />
      <BuyMeAChaiPage />
    </div>
  );
};

export default BuyMeAChai;
